import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { pageReload, getToken, triggerAlert, set_menu_details, set_user_permission } from '../utils';
import axios from 'axios';
import Cookies from 'js-cookie';
function Sidebar() {
    const location = useLocation();
    const api_url = process.env.REACT_APP_API_BASE_URL;
    const [menuState, setMenuState] = useState({
        // customers: false,
        // dids: false,
        // billing: false,
        // reports: false,
        // support: false,
        // number_portability: false,
        // endpoints: false,
        // manage_admin:false,
    });
    const [subMenuState, setSubMenuState] = useState({
        // customer_list: false,
        // create_customer: false,
        // active_customers: false,
        // create_service: false,
        // manage_service: false,
        // assigned_dids: false,
        // unassigned_dids: false,
        // order_dids: false,
        // billing_info: false,
        // payment_details: false,
        // create_invoice: false,
        // invoice: false,
        // balance_history: false,
        // transaction_history: false,
        // request_status: false,
        // endpoints: false,
        // coming_soon: false,
        // user_department:false,
        // user_logs_list:false,
        // user_level:false,
        // user_list:false,
        // user_menu:false,
        // menu_permission:false,

    });

    const [menuList, setMenuList] = useState([])
    const [userParentModules, setUserParentModules] = useState([]);
    const [userChildModules, setUserChildModules] = useState([]);

    const toggleMainMenu = (mainmenu) => {
        // setMenuState((prevState) => ({
        //     ...prevState,
        //     [mainmenu]: !prevState[mainmenu]
        // }));
        setMenuState((prevState) => {
            // Close any previously opened main menu
            const updatedState = { ...prevState };
            for (const key in updatedState) {
                if (key !== mainmenu) {
                    updatedState[key] = false;
                }
            }

            // Update the clicked main menu state
            updatedState[mainmenu] = !prevState[mainmenu];

            return updatedState;
        });
    };

    const toggleSubMenu = (submenu) => {
        // if (location.pathname === submenu) {
        //     pageReload();
        // }

        // const submodule = submenu.split("/")[2];
        // setSubMenuState((prevState) => ({
        //     ...prevState,
        //     [submodule]: !prevState[submodule]
        // }));
    };

    const fetchMenuList = async () => {
        try {

            const itemsArray = JSON.parse(sessionStorage.getItem('admin_menu_data'));

            // Initialize menuState and subMenuState based on menuList
            setMenuState((prevState) => {
                const menuStateObj = { ...prevState };
                itemsArray.forEach((item) => {
                    const mainMenuKey = item.page_name;
                    menuStateObj[mainMenuKey] = menuStateObj[mainMenuKey] || false;

                    if (item.submenu && item.submenu.length > 0) {
                        item.submenu.forEach((subItem) => {
                            const subMenuKey = subItem.page_name.split('/').pop();
                            menuStateObj[subMenuKey] = menuStateObj[subMenuKey] || false;
                            subItem.child_menu = subMenuKey; // Add this line
                        });
                    }
                });
                return menuStateObj;
            });

            setSubMenuState((prevState) => {
                const subMenuStateObj = { ...prevState };
                itemsArray.forEach((item) => {
                    if (item.submenu && item.submenu.length > 0) {
                        item.submenu.forEach((subItem) => {
                            const subMenuKey = subItem.page_name.split('/').pop();
                            subMenuStateObj[subMenuKey] = subMenuStateObj[subMenuKey] || false;
                        });
                    }
                });
                return subMenuStateObj;
            });

            // console.log("itemsArray", itemsArray);
            setMenuList(itemsArray);


        } catch (error) {
            // console.log('error', error);
            triggerAlert('error', 'Oops...', 'Something went wrong');
        }
    }

    const fetchUserPermissionData = async () => {

        try {


            const itemsArray = JSON.parse(sessionStorage.getItem('admin_permission_data'));

            const parent_id_string = itemsArray.parent_id;
            const parent_id_array = parent_id_string.split(',').map(Number);
            setUserParentModules(parent_id_array);

            ///////////////////////////////
            const child_id_string = itemsArray.child_id;
            const child_id_array = child_id_string.split(',').map(Number);
            setUserChildModules(child_id_array);





        } catch (error) {
            // triggerAlert('error', 'Oops...', 'Something went wrong..');
        }
    };
    const [customers, setcustomers] = useState(false)
    const [Billing, setBilling] = useState(false)
    const [Reports, setReports] = useState(false)
    const [Supports, setSupports] = useState(false)
    const [ManageAdmin, setManageAdmin] = useState(false)
    const [customerslist, setcustomerslist] = useState(false)
    const [Invoice, setInvoice] = useState(false)
    const [Revenue, setRevenue] = useState(false)
    const [Userlogs, setUserlogs] = useState(false)
    const [ManageTickets, setManageTickets] = useState(false)
    const [CreateTickets, setCreateTickets] = useState(false)
    const [TicketsCategories, setTicketsCategories] = useState(false)
    const [PredefinedReplies, setPredefinedReplies] = useState(false)
    const [UserLevel, setUserLevel] = useState(false)
    const [UserList, setUserList] = useState(false)
    const [Plans, setPlans] = useState(false)
    const [Products, setProducts] = useState(false)
    // Phase 5: Buycredit + Creditconfig state removed (wallet retired).
    const [settings, setsettings] = useState(false)
    const [Configurations, setConfigurations] = useState(false)
    const [ChatbotConfigurations, setChatbotConfigurations] = useState(false)
    const [AgentConfigurations, setAgentConfigurations] = useState(false)
    const [MenuPermissions, setMenuPermissions] = useState(false)
    const [ivr, setIvr] = useState(false)
    const [workflow, setWorkflow] = useState(false)
    const fetchMenuListApi = async () => {
        //let role_id = sessionStorage.getItem('user_type')
        // let token =sessionStorage.getItem("admin_user_token")
        let role_id = Cookies.get('user_type')
        let token = Cookies.get("admin_user_token")
        try {
            const response = await axios.get(`api/admin/module-mappings/?role_id=${role_id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            const response_data = response.data
            if (response.status === 200) {
                const itemsArray = response_data.results;
                //sessionStorage.setItem('modulepermissions',  JSON.stringify(itemsArray))
                Cookies.set('modulepermissions', JSON.stringify(itemsArray));
                showpageswith(response_data.results)
                setMenuList(itemsArray)
            } else if (response.status === 204) {

            }
            else {
                // triggerAlert('error', 'Oops...', 'Something went wrong here..');
            }

        } catch (error) {
            // triggerAlert('error', 'Oops...', 'Something went wrong..');
        }
    };

    const fetchUserPermissionDataApi = async () => {
        try {

            const response = await axios.get(api_url + 'manage_admin/admin_menu_by_id');
            const response_data = response.data

            if (response.status === 200) {
                const itemsArray = response_data.results[0];

                set_user_permission(itemsArray)
                fetchUserPermissionData();

            } else if (response.status === 204) {

            }
            else {
                // triggerAlert('error', 'Oops...', 'Something went wrong here..');
            }

        } catch (error) {
            // triggerAlert('error', 'Oops...', 'Something went wrong..');
        }
    };
    const showpageswith = (itemsArraysd) => {
        itemsArraysd.map((item, i) => {
            item.sub_module_info.map((submodule, i) => {
                if (submodule.name == "Customer List" && submodule.permissions.indexOf(1) !== -1) {
                    setcustomerslist(true)
                }

                if (submodule.name == "Invoice" && submodule.permissions.indexOf(1) !== -1) {
                    setInvoice(true)
                }

                if (submodule.name == "Revenue" && submodule.permissions.indexOf(1) !== -1) {
                    setRevenue(true)
                }

                if (submodule.name == "User logs" && submodule.permissions.indexOf(1) !== -1) {
                    setUserlogs(true)
                }
                if (submodule.name == "Manage Tickets" && submodule.permissions.indexOf(1) !== -1) {
                    setManageTickets(true)
                }
                if (submodule.name == "Create Tickets" && submodule.permissions.indexOf(1) !== -1) {
                    setCreateTickets(true)
                }
                if (submodule.name == "Tickets Categories" && submodule.permissions.indexOf(1) !== -1) {
                    setTicketsCategories(true)
                }
                if (submodule.name == "Predefined Replies" && submodule.permissions.indexOf(1) !== -1) {
                    setPredefinedReplies(true)
                }
                if (submodule.name == "User Role" && submodule.permissions.indexOf(1) !== -1) {
                    setUserLevel(true)
                }
                if (submodule.name == "User List" && submodule.permissions.indexOf(1) !== -1) {
                    setUserList(true)
                }
                if (submodule.name == "Access Privileges" && submodule.permissions.indexOf(1) !== -1) {
                    setMenuPermissions(true)
                }
                if (submodule.name == "Products" && submodule.permissions.indexOf(1) !== -1) {
                    setProducts(true)
                }
                if (submodule.name == "Plans" && submodule.permissions.indexOf(1) !== -1) {
                    setPlans(true)
                }
                // Phase 5: Credit Config / Buy Additional Credits permission checks removed (wallet retired).
                if (submodule.name == "Chatbot Configurations" && submodule.permissions.indexOf(1) !== -1) {
                    setChatbotConfigurations(true)
                }
                if (submodule.name == "Agent Configurations" && submodule.permissions.indexOf(1) !== -1) {
                    setAgentConfigurations(true)
                }

                if (submodule.name == "IVR Configurations" && submodule.permissions.indexOf(1) !== -1) {
                    setIvr(true)
                }

                if (submodule.name == "Workflow Configurations" && submodule.permissions.indexOf(1) !== -1) {
                    setWorkflow(true)
                }

            })

            if (item.module_info.name == "Customers" && item.module_info.permissions.indexOf(1) !== -1) {
                setcustomers(true)
            }

            if (item.module_info.name == "Billing" && item.module_info.permissions.indexOf(1) !== -1) {
                setBilling(true)
            }
            if (item.module_info.name == "Reports" && item.module_info.permissions.indexOf(1) !== -1) {
                setReports(true)
            }
            if (item.module_info.name == "Supports" && item.module_info.permissions.indexOf(1) !== -1) {
                setSupports(true)
            }
            if (item.module_info.name == "User Management" && item.module_info.permissions.indexOf(1) !== -1) {
                setManageAdmin(true)
            }
            if (item.module_info.name == "Settings" && item.module_info.permissions.indexOf(1) !== -1) {
                setsettings(true)
            }
            if (item.module_info.name == "Configurations" && item.module_info.permissions.indexOf(1) !== -1) {
                setConfigurations(true)
            }

        })
    }

    useEffect(() => {

        let itemsArraysd = JSON.parse(Cookies.get("modulepermissions"))
        if (itemsArraysd) {
            showpageswith(itemsArraysd)
        } else {
            fetchMenuListApi();
        }
        //fetchMenuListApi()
        let admin_menu_data = sessionStorage.getItem('admin_menu_data');
        if (admin_menu_data) {
            fetchMenuList();
        } else {

        }

        // let admin_permission_data = sessionStorage.getItem('admin_permission_data');
        // if(admin_permission_data){ 
        //     fetchUserPermissionData();
        // }else{
        //    // fetchUserPermissionDataApi()
        // } 

        if (location) {
            const path_name = location.pathname;
            const main_module = path_name.split("/")[1];
            const sub_module = path_name.split("/")[2];
            unsetData(sub_module);

            setMenuState((prevState) => ({
                ...prevState,
                [main_module]: true,
            }));
            setSubMenuState((prevState) => ({
                ...prevState,
                [sub_module]: true,
            }));
        }

    }, []);

    // Auto-open the Configurations group when the user lands on a related page
    // (SPA navigation, refresh, or deep link). User can still collapse it
    // manually — pure toggle behaviour lives on the <a> click handler.
    useEffect(() => {
        if (location.pathname.startsWith('/configurations')) {
            setMenuState((prev) => ({ ...prev, configurations: true }));
        }
    }, [location.pathname]);

    const unsetData = (pathname) => {
        if (pathname != 'request_status') {
            // sessionStorage.setItem('num_req_count', "0");
            Cookies.set('num_req_count', '0');
        }
        if (pathname != 'endpoints') {
            // sessionStorage.setItem('count', "0");
            Cookies.set('num_req_count', '0');

        }
        if (pathname != 'assigned_dids') {
            // sessionStorage.setItem('did_count', "0");
            Cookies.set('num_req_count', '0');
        }
    }

    //console.log(userParentModules);

    return (

        <div className="vertical-menu">
            {/* h-100 + overflow-y so the menu scrolls when it overflows the
                viewport (Velzon's simplebar handler doesn't always initialize
                in time, which leaves bottom items cut off on short windows). */}
            <div
                data-simplebar
                className="h-100"
                style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: '100vh' }}
            >
                {/* <!--- Sidemenu --> */}
                <div id="sidebar-menu">
                    {/* <!-- Left Menu Start --> */}
                    <ul className="metismenu list-unstyled" id="side-menu">



                        <li className={location.pathname === '/dashboard' ? 'mm-active' : ''} >
                            <Link to="/dashboard" className={location.pathname === '/dashboard' ? 'active' : ''}>
                                <i className="bx  bx bx-home-alt"></i>
                                <span data-key="t-dashboard">Dashboard</span>
                            </Link>
                        </li>
                        {customers && customerslist ?
                            <li className={menuState['customers'] ? 'mm-active' : ''} onClick={() => toggleMainMenu('customers')}>
                                <a role='button' className="has-arrow waves-effect" aria-expanded={menuState['customers']} >
                                    <i className="bx bx-user-circle"></i>
                                    <span data-key="t-ui-elements">Customers</span>
                                </a>
                                <ul className={menuState['customers'] ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={menuState['customers']}>
                                    {customerslist &&
                                        <li className={subMenuState['customerslist'] ? 'mm-active' : ''}>
                                            <Link to="/customers/customerslist" data-key="t-lightbox" className={subMenuState['customerslist'] ? 'active' : ''} onClick={() => toggleSubMenu('/manage_user/customerslist')}>Customers List</Link>
                                        </li>}

                                </ul>
                            </li> : ""}
                        {Billing && Invoice ?
                            <li className={menuState['billing'] ? 'mm-active' : ''} onClick={() => toggleMainMenu('billing')}>
                                <a role='button' className="has-arrow waves-effect" aria-expanded={menuState['billing']} >
                                    <i className="mdi mdi-account-cash-outline"></i>
                                    <span data-key="t-pages">Billing</span>
                                </a>
                                <ul className={menuState['billing'] ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={menuState['billing']}>
                                    {/* Observe-only billing over the new AgentSubscription stack. */}
                                    <li className={subMenuState['subscriptions'] ? 'mm-active' : ''}>
                                        <Link to="/billing/subscriptions" data-key="t-starter-page" className={subMenuState['subscriptions'] ? 'active' : ''} onClick={() => toggleSubMenu('/billing/subscriptions')}>
                                            Subscriptions</Link>
                                    </li>
                                    <li className={subMenuState['invoice'] ? 'mm-active' : ''}>
                                        <Link to="/billing/invoice" data-key="t-coming-soon" className={subMenuState['invoice'] ? 'active' : ''} onClick={() => toggleSubMenu('/billing/invoice')}>
                                            Invoices</Link>
                                    </li>
                                </ul>
                            </li> : ""}
                        {Reports && (Revenue || Userlogs) ?
                            <li className={menuState['reports'] ? 'mm-active' : ''} onClick={() => toggleMainMenu('reports')}>
                                <a href="#/" className="has-arrow waves-effect" aria-expanded={menuState['reports']} >
                                    <i className="mdi mdi-file-document-multiple-outline"></i>
                                    <span data-key="t-components">Reports</span>
                                </a>
                                <ul className={menuState['reports'] ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={menuState['reports']}>

                                    {Revenue && <li className={subMenuState['revenue'] ? 'mm-active' : ''}><Link to="/reports/revenue" data-key="t-buttons" className={subMenuState['revenue'] ? 'active' : ''} onClick={() => toggleSubMenu('/revenue')}>Revenue</Link></li>}
                                    {Userlogs && <li className={subMenuState['user_logs_list'] ? 'mm-active' : ''}><Link to="/reports/user_logs_list" data-key="t-cards" className={subMenuState['user_logs_list'] ? 'active' : ''} onClick={() => toggleSubMenu('/user_logs_list')}>User Logs</Link></li>}
                                    {/* <li className={subMenuState['user_calllogs_list'] ? 'mm-active' : ''}><Link to="/customermanagement" data-key="t-cards" className={subMenuState['user_calllogs_list'] ? 'active' : ''} onClick={() => toggleSubMenu('/user_calllogs_list')}>User call logs</Link></li> */}
                                </ul>
                            </li> : ""}
                        {Supports && (ManageTickets || CreateTickets || TicketsCategories || PredefinedReplies) ?
                            <li className={menuState['support'] ? 'mm-active' : ''} onClick={() => toggleMainMenu('support')}>
                                <a role='button' className="has-arrow waves-effect" aria-expanded={menuState['support']} >
                                    <i className="mdi mdi-headset"></i>
                                    <span data-key="t-ui-elements">Supports</span>
                                </a>
                                <ul className={menuState['support'] ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={menuState['support']}>
                                    {ManageTickets && <li className={subMenuState['manage_tickets'] ? 'mm-active' : ''}>
                                        <Link to="/support/manage_tickets" data-key="t-lightbox" className={subMenuState['manage_tickets'] ? 'active' : ''} onClick={() => toggleSubMenu('/support/manage_tickets')}>Manage Tickets</Link></li>}
                                    {CreateTickets && <li className={subMenuState['create_tickets'] ? 'mm-active' : ''}>
                                        <Link to="/support/create_tickets" data-key="t-range-slider" className={subMenuState['create_tickets'] ? 'active' : ''} onClick={() => toggleSubMenu('/support/create_tickets')}>Create Tickets</Link></li>}
                                    {TicketsCategories && <li className={subMenuState['categories'] ? 'mm-active' : ''}>
                                        <Link to="/support/categories" data-key="t-sweet-alert" className={subMenuState['categories'] ? 'active' : ''} onClick={() => toggleSubMenu('/support/categories')}>Ticket Categories</Link></li>}
                                    {TicketsCategories && <li className={subMenuState['create_categories'] ? 'mm-active' : ''}>
                                        <Link to="/support/create_categories" data-key="t-session-timeout" className={subMenuState['create_categories'] ? 'active' : ''} onClick={() => toggleSubMenu('/support/create_categories')}>Create Categories</Link>
                                    </li>}
                                    {PredefinedReplies && <li className={subMenuState['predefined_replies'] ? 'mm-active' : ''}>
                                        <Link to="/support/predefined_replies" data-key="t-session-timeout" className={subMenuState['predefined_replies'] ? 'active' : ''} onClick={() => toggleSubMenu('/support/predefined_replies')}>Predefined Replies</Link>
                                    </li>}
                                    {/* <li className={subMenuState['customer_notes'] ? 'mm-active' : ''}>
                                    <Link to="/support/customer_notes" data-key="t-session-timeout" className={subMenuState['customer_notes'] ? 'active' : ''} onClick={() => toggleSubMenu('/support/customer_notes')}>Customer Notes</Link>
                                </li> */}
                                </ul>
                            </li> : ""}
                        {ManageAdmin && (MenuPermissions || UserLevel || UserList) ?
                            <li className={menuState['manage_user'] ? 'mm-active' : ''} onClick={() => toggleMainMenu('manage_user')}>
                                <a role='button' className="has-arrow waves-effect" aria-expanded={menuState['manage_user']} >
                                    <i className="bx bx-user"></i>
                                    <span data-key="t-ui-elements">User Management</span>
                                </a>
                                <ul className={menuState['manage_user'] ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={menuState['manage_user']}>
                                    {UserList && <li className={subMenuState['user_list'] ? 'mm-active' : ''}>
                                        <Link to="/manage_user/user_list" data-key="t-lightbox" className={subMenuState['user_list'] ? 'active' : ''} onClick={() => toggleSubMenu('/manage_user/user_list')}>User List</Link>
                                    </li>}
                                    {UserLevel && <li className={subMenuState['user_roles'] ? 'mm-active' : ''}>
                                        <Link to="/manage_user/user_roles" data-key="t-lightbox" className={subMenuState['user_roles'] ? 'active' : ''} onClick={() => toggleSubMenu('/manage_user/user_roles')}>User Roles</Link>
                                    </li>}
                                    {MenuPermissions && <li className={subMenuState['access_privileges'] ? 'mm-active' : ''}>
                                        <Link to="/manage_user/access_privileges" data-key="t-lightbox" className={subMenuState['access_privileges'] ? 'active' : ''} onClick={() => toggleSubMenu('/manage_user/access_privileges')}>Access Privileges</Link>
                                    </li>}
                                </ul>
                            </li> : ""}
                        {settings ?
                            <li className={menuState['settings'] ? 'mm-active' : ''} onClick={() => toggleMainMenu('settings')}>
                                <a role='button' className="has-arrow waves-effect" aria-expanded={menuState['settings']} >
                                    <i className="bx bx-cog"></i>
                                    <span data-key="t-ui-elements">Settings</span>
                                </a>
                                <ul className={menuState['settings'] ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={menuState['settings']}>
                                    {/* {Products && 
                                <li className={subMenuState['products'] ? 'mm-active' : ''}>
                                    <Link to="/settings/products" data-key="t-lightbox" className={subMenuState['products'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/products')}>Products</Link>
                                </li>} */}
                                    {Plans &&
                                        <li className={subMenuState['phone-number-pricing'] ? 'mm-active' : ''}>
                                            <Link to="/settings/phone-number-pricing" data-key="t-lightbox" className={subMenuState['phone-number-pricing'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/phone-number-pricing')}>Phone Number Pricing</Link>
                                        </li>}

                                    {Plans &&
                                        <li className={subMenuState['agent-plans'] ? 'mm-active' : ''}>
                                            <Link to="/settings/agent-plans" data-key="t-lightbox" className={subMenuState['agent-plans'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/agent-plans')}>Plan Audit</Link>
                                        </li>}

                                    {/* White-label branding for the deployment. Reseller-owned so we
                                        intentionally surface this even when Plans permissions are absent. */}
                                    <li className={subMenuState['branding'] ? 'mm-active' : ''}>
                                        <Link to="/settings/branding" data-key="t-lightbox" className={subMenuState['branding'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/branding')}>Branding</Link>
                                    </li>

                                    {/* Free-trial policy — master enable + per-category allowance.
                                        Read by the marketplace subscribe modal to decide whether to
                                        show the "Start free trial" button. */}
                                    <li className={subMenuState['free-trials'] ? 'mm-active' : ''}>
                                        <Link to="/settings/free-trials" data-key="t-lightbox" className={subMenuState['free-trials'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/free-trials')}>Free Trials</Link>
                                    </li>

                                    {/* Terms & Conditions singleton — content shown in the customer
                                        portal's scroll-to-accept popup. Version bumps on save and
                                        every customer is re-prompted on next login. */}
                                    <li className={subMenuState['terms-and-conditions'] ? 'mm-active' : ''}>
                                        <Link to="/settings/terms-and-conditions" data-key="t-lightbox" className={subMenuState['terms-and-conditions'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/terms-and-conditions')}>Terms &amp; Conditions</Link>
                                    </li>

                                    {/* KYC review queue for orgs buying US phone numbers. TCPA /
                                        carrier compliance — three docs (EIN, incorporation cert,
                                        card-holder address proof) must be approved before Buy
                                        Numbers unlocks for the customer. */}
                                    <li className={subMenuState['phone-verifications'] ? 'mm-active' : ''}>
                                        <Link to="/settings/phone-verifications" data-key="t-lightbox" className={subMenuState['phone-verifications'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/phone-verifications')}>Phone Verifications</Link>
                                    </li>

                                    {/* Number porting queue — customers asking to bring an
                                        existing number in from another carrier. Sits beside
                                        Phone Verifications because it is the same kind of
                                        manual compliance review, and is ungated for the same
                                        reason as its neighbours. */}
                                    <li className={subMenuState['port-requests'] ? 'mm-active' : ''}>
                                        <Link to="/settings/port-requests" data-key="t-lightbox" className={subMenuState['port-requests'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/port-requests')}>Port Requests</Link>
                                    </li>

                                    {/* Deployment-wide billing knobs (AmEx surcharge, etc.). Also
                                        reseller-owned; always surfaced when Settings is visible. */}
                                    <li className={subMenuState['payment-behavior'] ? 'mm-active' : ''}>
                                        <Link to="/settings/payment-behavior" data-key="t-lightbox" className={subMenuState['payment-behavior'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/payment-behavior')}>Payment Behavior</Link>
                                    </li>

                                    <li className={subMenuState['coupons'] ? 'mm-active' : ''}>
                                        <Link to="/settings/coupons" data-key="t-lightbox" className={subMenuState['coupons'] ? 'active' : ''} onClick={() => toggleSubMenu('/settings/coupons')}>Coupons</Link>
                                    </li>

                                    {/* Help Center — the video library customers search from
                                        their portal. Reseller-owned content like Branding, so
                                        it is surfaced whenever Settings is visible. */}
                                    <li className={subMenuState['help-center-videos'] ? 'mm-active' : ''}>
                                        <Link to="/settings/help-center-videos" data-key="t-lightbox" className={subMenuState['help-center-videos'] ? 'active' : ''} onClick={() => toggleSubMenu("/settings/help-center-videos")}>Help Center Videos</Link>
                                    </li>

                                    <li className={subMenuState['help-center-categories'] ? 'mm-active' : ''}>
                                        <Link to="/settings/help-center-categories" data-key="t-lightbox" className={subMenuState['help-center-categories'] ? 'active' : ''} onClick={() => toggleSubMenu("/settings/help-center-categories")}>Help Center Categories</Link>
                                    </li>
                                </ul>
                            </li> : ""}
                        {Configurations && (ChatbotConfigurations || AgentConfigurations || ivr || workflow) ? (() => {
                            const onConfigPath = location.pathname.startsWith('/configurations');
                            // Active = highlighted (driven by path so the parent
                            // stays highlighted even if the user collapses it).
                            // Open = expanded (driven solely by menuState so the
                            // user can toggle freely while on a configs page).
                            const isOpen = !!menuState['configurations'];
                            return (
                                <li className={(isOpen || onConfigPath) ? 'mm-active' : ''}>
                                    <a role='button' className="has-arrow waves-effect" aria-expanded={isOpen} onClick={() => toggleMainMenu('configurations')}>
                                        <i className={`bx bx-customize${onConfigPath ? ' parent-child-active' : ''}`}></i>
                                        <span data-key="t-ui-elements">Configurations</span>
                                    </a>
                                    <ul className={isOpen ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={isOpen}>
                                        {ChatbotConfigurations &&
                                            <li className={location.pathname === '/configurations/chatbotconfigurations' ? 'mm-active' : ''}>
                                                <Link to="/configurations/chatbotconfigurations" data-key="t-lightbox" className={location.pathname === '/configurations/chatbotconfigurations' ? 'active' : ''} onClick={() => toggleSubMenu('/configurations/chatbotconfigurations')}>Avatar Chatbots</Link>
                                            </li>}

                                        <li className={location.pathname === '/configurations/aiworkflows' ? 'mm-active' : ''}>
                                            <Link to="/configurations/aiworkflows" data-key="t-lightbox" className={location.pathname === '/configurations/aiworkflows' ? 'active' : ''} onClick={() => toggleSubMenu('/configurations/aiworkflows')}>AI Workflows</Link>
                                        </li>

                                    </ul>
                                </li>
                            );
                        })() : ""}

                        {/* Calling V2 — new agents running on the Calling Runtime. Lives alongside V1 during transition. */}
                        {(() => {
                            const v2Paths = ['/v2/templates', '/v2/knowledge-templates', '/v2/ivr-templates', '/v2/tools', '/v2/hold-music', '/v2/summary-config'];
                            const onV2 = v2Paths.some(p => location.pathname.startsWith(p));
                            const isOpenV2 = !!menuState['callingv2'];
                            return (
                                <li className={(isOpenV2 || onV2) ? 'mm-active' : ''}>
                                    <a role='button' className="has-arrow waves-effect" aria-expanded={isOpenV2} onClick={() => toggleMainMenu('callingv2')}>
                                        <i className={`bx bx-phone-call${onV2 ? ' parent-child-active' : ''}`}></i>
                                        <span>Calling Agents</span>
                                    </a>
                                    <ul className={isOpenV2 ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'} aria-expanded={isOpenV2}>
                                        <li className={location.pathname.startsWith('/v2/templates') ? 'mm-active' : ''}>
                                            <Link to="/v2/templates" data-key="t-lightbox" className={location.pathname.startsWith('/v2/templates') ? 'active' : ''} onClick={() => toggleSubMenu('/v2/templates')}>Agent Templates</Link>
                                        </li>
                                        <li className={location.pathname === '/v2/knowledge-templates' ? 'mm-active' : ''}>
                                            <Link to="/v2/knowledge-templates" data-key="t-lightbox" className={location.pathname === '/v2/knowledge-templates' ? 'active' : ''} onClick={() => toggleSubMenu('/v2/knowledge-templates')}>Knowledge Templates</Link>
                                        </li>
                                        <li className={location.pathname === '/v2/ivr-templates' ? 'mm-active' : ''}>
                                            <Link to="/v2/ivr-templates" data-key="t-lightbox" className={location.pathname === '/v2/ivr-templates' ? 'active' : ''} onClick={() => toggleSubMenu('/v2/ivr-templates')}>IVR Templates</Link>
                                        </li>
                                        <li className={location.pathname === '/v2/tools' ? 'mm-active' : ''}>
                                            <Link to="/v2/tools" data-key="t-lightbox" className={location.pathname === '/v2/tools' ? 'active' : ''} onClick={() => toggleSubMenu('/v2/tools')}>Tool Catalog</Link>
                                        </li>
                                        <li className={location.pathname === '/v2/hold-music' ? 'mm-active' : ''}>
                                            <Link to="/v2/hold-music" data-key="t-lightbox" className={location.pathname === '/v2/hold-music' ? 'active' : ''} onClick={() => toggleSubMenu('/v2/hold-music')}>Hold Music</Link>
                                        </li>
                                        <li className={location.pathname === '/v2/summary-config' ? 'mm-active' : ''}>
                                            <Link to="/v2/summary-config" data-key="t-lightbox" className={location.pathname === '/v2/summary-config' ? 'active' : ''} onClick={() => toggleSubMenu('/v2/summary-config')}>Call Summary</Link>
                                        </li>
                                    </ul>
                                </li>
                            );
                        })()}



                    </ul>
                </div>
                {/* <!-- Sidebar --> */}
            </div>
        </div>
    );
}

export default Sidebar;
